import styled from "styled-components"
export const BlogSectionTitle = styled.h2`
  font-size: 96px;
  text-align: center;
  font-weight: 500;
  margin: 50px 0 0 0;
`
